import { Component, Input, OnInit } from '@angular/core';
import { NbMenuService, NbSidebarService } from '@nebular/theme';
import { UserService } from '../../../@core/data/users.service';
import { AnalyticsService } from '../../../@core/utils/analytics.service';
import { LayoutService } from '../../../@core/data/layout.service';
import *as firebase from 'firebase';
import { UserServiceProvider } from '../../../../providers/user-service/user-service';
import { Router } from '@angular/router';
import { ActivatedRoute } from "@angular/router";
import { environment } from '../../../../environments/environment'

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

  @Input() position = 'normal';
  user: any;
  userMenu = [{ title: 'Profile' }, { title: 'Log out' }];
  loggedinuser: any;
  env = environment;
  userType: any = '';
  constructor(private route: ActivatedRoute, private router: Router, private userservice: UserServiceProvider, private sidebarService: NbSidebarService, private menuService: NbMenuService,
    private userService: UserService,
    private analyticsService: AnalyticsService,
    private layoutService: LayoutService) {
  }

  ngOnInit() {
    //this.userService.getUsers().subscribe((users: any) => this.user = users.nick);
    var user = JSON.parse(sessionStorage.getItem('loggedin'));
    console.log(user);
    if (user != null && user.type == 'admin') {
      this.userservice.getloggedinuserdetail(user.type, user.uid).subscribe((res: any) => {
        console.log('header....', res)
        this.env.roles = res.roles
        this.loggedinuser = res;
        this.userType = res.type;
        console.log(this.loggedinuser);
      })
    } else if (user != null && user.type == 'employee') {
      this.userservice.getloggedinuserdetail(user.type, user.uid).subscribe((res: any) => {
        this.loggedinuser = res;
      })
    } else {
      alert('you are not an admin nor employee')
      // this.router.navigateByUrl('/');
    }
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  toggleSettings(): boolean {
    this.sidebarService.toggle(false, 'settings-sidebar');

    return false;
  }

  goToHome() {
    this.menuService.navigateHome();
  }

  startSearch() {
    this.analyticsService.trackEvent('startSearch');
  }

  logout() {
    firebase.auth().signOut().then(() => {
      sessionStorage.removeItem('loggedin');
      this.router.navigateByUrl('/');
    })
  }
}
